export const Story = () => {
  // Image gallery for the story section
  const galleryImages = [
    'christian-mackie-cc-0-gg-3-begj-e-unsplash-10.png',
    'aranprime-kbyt-cp-i-1-i-5-i-unsplash-10.png',
    'alexandra-gorn-w-5-dsm-9-n-6-e-3-g-unsplash-10.png',
    'nastuh-abootalebi-r-sp-mla-5-r-it-a-unsplash-10.png',
    'lakeisha-bennett-wz-p-3-yn-v-9-t-u-unsplash-10.png',
  ];

  return (
    <section className="section-container">
      <div className="card flex flex-col items-start gap-8 md:gap-10">
        {/* Section header */}
        <div className="section-title">
          <div className="section-title-prefix">our</div>
          <div className="section-title-main">Story</div>
        </div>

        {/* Image gallery */}
        <div className="flex w-full flex-row flex-wrap items-center justify-start gap-4 overflow-hidden sm:h-60 md:h-80">
          {galleryImages.map((img) => (
            <img
              key={img}
              className="h-auto min-w-[150px] flex-1 object-cover sm:h-[216px] md:h-[260px] lg:h-auto"
              src={img}
              alt={`Interior design example featuring ${img.split('/').pop().split('-')[0]} styling`}
              loading="lazy"
            />
          ))}
        </div>

        {/* Primary description */}
        <div className="body-text">
          Furnitech was born out of a passion for creating spaces that inspire.
          What started as a small team of design enthusiasts has grown into a
          platform where innovation meets personalization. We believe that every
          space has a story to tell, and our mission is to help you write yours
          — whether it&apos;s a cozy home, a vibrant office, or anything in
          between.
        </div>

        {/* Feature box */}
        <div className="flex w-full flex-col gap-6 overflow-hidden rounded-[10px] md:flex-row md:rounded-[20px]">
          <div className="flex w-full flex-row items-center justify-center gap-2.5 bg-secondary-secondary-05 p-6 md:p-10">
            <div className="body-text">
              With a focus on individuality, quality, and functionality,{' '}
              we&apos;re here to make your vision a reality.
              <br />
              <br />
              At Furnitech, it&apos;s not just about furniture — it&apos;s about{' '}
              crafting spaces that reflect who you are.
            </div>
          </div>
          <img
            className="h-auto w-full object-cover md:h-auto md:max-h-[334px] md:w-[413px]"
            src="image1.png"
            alt="Interior design showcase"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};
